export const formatArea = (value: number | undefined) => {
  if (!value) {
    return;
  }

  return `${value} м²`;
};
